import { Stack, Tooltip, Typography } from '@mui/material';
import { People, ContentPaste, RestoreOutlined } from '@mui/icons-material';
import * as S from './Icons.styled';
import { isNil } from '@shared';

type PropsType = {
  studentCount?: number;
  examCount?: number;
  completedExamCount?: number;
  titles: string[];
  recordOnly?: boolean;
};

export const IconsNew = ({
  recordOnly = false,
  titles,
  studentCount,
  examCount,
  completedExamCount,
}: PropsType) => {
  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      {recordOnly && (
        <Tooltip title='Record Only Exam' placement='top' arrow>
          <S.CellNew>
            <Typography variant='iconCell'>Record Only</Typography>
          </S.CellNew>
        </Tooltip>
      )}
      {!isNil(studentCount) && (
        <Tooltip title={titles.at(0)} placement='top' arrow>
          <Stack direction='row' gap='5px' alignItems='center'>
            <People fontSize='small' color='primary' />
            <Typography color='primary'>{studentCount}</Typography>
          </Stack>
        </Tooltip>
      )}
      {!isNil(examCount) && (
        <Tooltip title={titles.at(1)} placement='top' arrow>
          <Stack direction='row' gap='5px' alignItems='center'>
            <ContentPaste fontSize='small' color='primary' />
            <Typography color='primary'>{examCount}</Typography>
          </Stack>
        </Tooltip>
      )}
      {!isNil(completedExamCount) && (
        <Tooltip title={titles.at(2)} placement='top' arrow>
          <Stack direction='row' gap='5px' alignItems='center'>
            <RestoreOutlined fontSize='small' color='primary' />
            <Typography color='primary'>{completedExamCount}</Typography>
          </Stack>
        </Tooltip>
      )}
    </Stack>
  );
};
